import defaultTheme from './themedefault';
import _clone from 'lodash/cloneDeep';

const theme = _clone(defaultTheme);

theme.palette.primary = ['#f00'];
theme.palette.secondary = ['#0f0'];
export default theme;
